import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon';
import './stylesheets/ErrorState.scss';

const renderRetryLink = (retry) => {
  if (retry) {
    /* eslint-disable */
    return <a className="try-again-link" onClick={ retry }>Try again</a>;
    /* eslint-enable */
  }
};

export default function ErrorState({ retry, message }) {
  return (
    <div className="widgetopia error-state">
      <h2 className="error-icon-wrapper"><Icon icon="alert" /></h2>
      <p className="error-message">{ message }</p>
      { renderRetryLink(retry) }
    </div>
  );
}

ErrorState.propTypes = {
  message: PropTypes.string.isRequired,
  /** function that retries that action that errored */
  retry: PropTypes.func
};

ErrorState.defaultProps = {
  message: 'We ran into a problem loading this item'
};



// WEBPACK FOOTER //
// ./node_modules/@localytics/loc-components/lib/ErrorState.jsx